export const allColors = {
  neutral70: '#B8BEC9',
  neutral60: '#D5D8DF',
  neutral50: '#F2F3F5',
  neutral40: '#FCFBFC',
  white: '#FFFFFF',
  ink70: 'black',
  ink60: '#212224',
  ink50: '#393B3F',
  ink40: '#60636A',
  ink30: '#A4A8AE',
  purple90: '#1e2ab5',
  purple80: '#1e2ab5',
  purple70: '#3430BD',
  purple60: '#4637c6',
  purple50: '#513CCC',
  purple40: '#7058d4',
  purple30: '#8b76dc',
  purple20: '#AD9EE5',
  purple10: '#CEC4EF',
  red90: '#1e2ab5',
  red80: '#1e2ab5',
  red70: '#ce4528',
  red60: '#dc4c2b',
  red50: '#ea5230',
  red40: '#f5804f',
  red30: '#f68a6e',
  red20: '#f8aa97',
  red10: '#FACBBF',
  yellow90: '#1e2ab5',
  yellow80: '#FF9100',
  yellow70: '#ce4528',
  yellow60: '#dc4c2b',
  yellow50: '#ea5230',
  yellow40: '#f5704F',
  yellow30: '#f68a6e',
  yellow20: '#f8aa97',
  yellow10: '#FFEDB3',
  lemon: '#F3EFA1',
};

export const baseColor = {
  background: allColors.white,
  ink: allColors.ink50,
  action: allColors.purple50,
  negative: allColors.red50,
  warning: allColors.yellow50,
};

export const invertTheme = ({ background, font }) => ({
  background: font,
  font: background,
});
